<template>
  <div class="content">
    <div class="content-header">
      <button class="content-header__exit" @click="logout">Выйти</button>
      <RouterLink :to="{name: 'general-testing'}" class="content-header__close"><i class="fas fa-times"></i></RouterLink>
    </div>
    <div class="content-header__title">{{ pageTitle }}</div>
    <div class="content-main">
      <div class="content-main_desc">
        <div class="general-testing-back">
          <RouterLink :to="{name: 'general-testing'}">← К списку блоков</RouterLink>
        </div>
        <div v-if="isLoading" class="general-testing-state">Загрузка...</div>
        <div v-else-if="tests.length === 0" class="general-testing-state">
          Тесты в этом блоке пока не найдены
        </div>
        <div v-else class="general-testing-list">
          <RouterLink
            v-for="test in tests"
            :key="test.id"
            :to="{name: 'general-testing-test', params: {blockId: route.params.id, testId: test.id}}"
            class="general-testing-card"
          >
            <div class="general-testing-card__head">
              <div class="general-testing-card__title">{{ test.title }}</div>
              <div class="general-testing-card__arrow"><i class="fas fa-chevron-right"></i></div>
            </div>
            <div class="general-testing-card__stats">
              <div class="general-testing-card__stat">
                <span class="general-testing-card__label">Всего вопросов</span>
                <strong>{{ test.questionsCount }}</strong>
              </div>
              <div class="general-testing-card__stat">
                <span class="general-testing-card__label">Пройдено</span>
                <strong>{{ test.completedQuestionsCount }}</strong>
              </div>
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, inject, onMounted, ref} from "@vue/runtime-core";
import {useRoute} from "vue-router";
import {getGeneralTestingBlock} from "@/data/requests";

const getCount = (item, keys) => {
  for (const key of keys) {
    if (typeof item?.[key] === 'number') return item[key];
  }

  for (const key of keys) {
    if (Array.isArray(item?.[key])) return item[key].length;
  }

  return 0;
};

const normalizeTest = (test, index) => {
  return {
    id: test?.id ?? index,
    title: test?.title ?? test?.name ?? test?.label ?? `Тест ${index + 1}`,
    questionsCount: getCount(test, [
      'questions_count',
      'questionsCount',
      'total_questions_count',
      'totalQuestionsCount',
      'questions'
    ]),
    completedQuestionsCount: getCount(test, [
      'completed_questions_count',
      'completedQuestionsCount',
      'passed_questions_count',
      'passedQuestionsCount',
      'completed_questions',
      'completedQuestions',
      'passed_questions',
      'passedQuestions'
    ])
  };
};

export default {
  setup() {
    const logout = inject('logout');
    const token = inject('token');
    const route = useRoute();
    const tests = ref([]);
    const blockTitle = ref('');
    const isLoading = ref(true);

    const pageTitle = computed(() => blockTitle.value || 'Тесты блока');

    async function loadData() {
      isLoading.value = true;
      const response = await getGeneralTestingBlock(token.value, route.params.id);

      blockTitle.value = response?.title ?? response?.name ?? response?.label ?? '';

      const rawTests = Array.isArray(response)
        ? response
        : response?.tests ?? response?.items ?? response?.data ?? [];

      tests.value = rawTests.map(normalizeTest);
      isLoading.value = false;
    }

    onMounted(loadData);

    return {logout, tests, isLoading, pageTitle, route};
  }
}
</script>

<style scoped lang="scss">
.content-main_desc {
  max-width: 900px;
  width: 100%;
}

.general-testing-back {
  margin-top: 20px;
}

.general-testing-back a {
  color: #00669c;
  text-decoration: none;
}

.general-testing-state {
  margin-top: 20px;
  font-size: 16px;
}

.general-testing-list {
  display: grid;
  gap: 16px;
  margin-top: 20px;
}

.general-testing-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  color: inherit;
  text-decoration: none;
}

.general-testing-card__head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.general-testing-card__title {
  font-size: 22px;
  line-height: 1.3;
}

.general-testing-card__arrow {
  color: #00669c;
  flex: 0 0 auto;
  margin-top: 4px;
}

.general-testing-card__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.general-testing-card__stat {
  background: #f5f9fc;
  border-radius: 10px;
  padding: 16px;
}

.general-testing-card__label {
  display: block;
  font-size: 13px;
  color: #6b7a83;
  margin-bottom: 8px;
}

.general-testing-card__stat strong {
  font-size: 26px;
  color: #00669c;
}

@media all and (max-width: 768px) {
  .general-testing-card {
    padding: 18px;
  }

  .general-testing-card__title {
    font-size: 18px;
  }

  .general-testing-card__stats {
    grid-template-columns: 1fr;
  }
}
</style>
